module.exports = __webpack_public_path__ + "static/media/documentation.a6cd0208.md";